import React, { FC, memo } from 'react';
import { RentOptionDocument, AccountTypeSetting } from 'entities/RentOption';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { getLocalizedString } from 'shared/utils/helpers/JSONLocalization';
import { ReactComponent as FireIcon } from 'shared/assets/icons/newIcons/FireIcon.svg';
import { FeaturesList } from 'shared/ui/FeaturesList';

interface RentOptionCardProps {
  rentOption: RentOptionDocument;
}

export const RentOptionCard: FC<RentOptionCardProps> = memo((props) => {
  const { rentOption } = props;
  const { label, description, accountTypeSetting } = rentOption;

  const { t } = useAppTranslation('booking');

  const accountTypesMap: Record<AccountTypeSetting, string> = {
    [AccountTypeSetting.ALL]: t('For business and personal use'),
    [AccountTypeSetting.PERSONAL]: t('For personal use'),
    [AccountTypeSetting.BUSINESS]: t('For business'),
  };

  return (
    <div className="bg-white border-2 border-yellow-400 rounded-lg p-4 mb-4">
      <div className="flex items-center gap-3 mb-2">
        <FireIcon className="w-8 h-8 text-orange-500 flex-shrink-0" />
        <h3 className="text-lg font-bold text-gray-900 font-tektur">{getLocalizedString(label)}</h3>
      </div>

      {description && <p className="text-md text-gray-600 leading-relaxed mb-3">{getLocalizedString(description)}</p>}

      <FeaturesList features={accountTypesMap[accountTypeSetting]} theme="warning" size="sm" />
    </div>
  );
});
